import { BaseAutoTestStep } from './base';
import { errOrData, mergeEithers } from './utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class RunProgramAutoTestStep extends BaseAutoTestStep {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    parseInputData(data) {
        return data;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    getDataToSave() {
        return mergeEithers(this._baseGetDataToSave(), errOrData(this._checkProgramNotEmpty(), { data: this.data, type: this.type }));
    }
}
